// Please

export enum Routes {
    //must not contain "admin" in url
    home = '',
    test = 'test',
    company_registration = 'company-registration',
    not_found = 'not-found',
    contact = 'contact',
    news = 'news',

    //user
    user = 'user',
    dashboard = 'user/dashboard',
    dashboard_my_company = 'user/dashboard/my-company',
    product = 'user/product',
    product_new = 'user/product/product-new',
    product_edit = 'user/product/product-edit',
    service = 'user/service',
    oil_test_engines = 'user/oil-test-engines',

    //admin Route
    admin = 'admin',
    admin_missing_permission = 'admin/missing-permission',

    //admin subroutes must contain "/admin"
    admin_dashboard = 'admin/dashboard',

    admin_products = 'admin/products ',
    admin_products_overview = 'admin/products/products-overview',
    admin_products_share = 'admin/products/share',
    admin_processes_overview = 'admin/products/processes-overview',

    admin_master_data = 'admin/master-data',
    admin_master_data_sheet_care = 'admin/master-data/sheet-care',
    admin_master_data_product_care = 'admin/master-data/product-care',
    admin_master_data_area_care = 'admin/master-data/area-care',
    admin_master_data_test_care = 'admin/master-data/test-care',
    admin_master_data_additive_baseoil_care = 'admin/master-data/additive-baseoil-care',

    admin_client_registrations = 'admin/client',
    admin_client_registrations_details = 'admin/client/registration-details',
    admin_client_registrations_details_id = 'admin/client/registration-details_id',
    admin_client_registrations_manage = 'admin/client/registration-manage',
    admin_client_registrations_manage_id = 'admin/client/registration-manage_id',
    admin_client_registrations_change = 'admin/client/registration-change',
    admin_client_registrations_change_id = 'admin/client/registration-change_id',
    admin_client_invoices = 'admin/client/invoices',

    admin_test_aggregates = 'admin/test-aggregates',
    admin_test_aggregates_cert = 'admin/test-aggregates/certificate',
    admin_test_aggregates_oil_testing_engine_tests = 'admin/test-aggregates/oil-testing-engine-tests',
    admin_test_aggregates_oil_testing_engine_tests_new = 'admin/test-aggregates/oil-testing-engine-tests/oil-testing-engine-tests-new',
    admin_test_aggregates_oil_testing_engine_tests_test_details = 'admin/test-aggregates/oil-testing-engine-tests/test-details',
    admin_test_aggregates_oil_testing_engine_tests_test_details_id = 'admin/test-aggregates/oil-testing-engine-tests/test-details/test-details_id',
    admin_test_aggregates_oil_testing_engine_master_data = 'admin/test-aggregates/oil-testing-engine-master-data',
    admin_test_aggregates_oil_testing_engine_master_data_engine_types_edit = 'admin/test-aggregates/oil-testing-engine-master-data/engine-types-edit',
    admin_test_aggregates_oil_testing_engine_master_data_engine_types_new = 'admin/test-aggregates/oil-testing-engine-master-data/engine-types-new',
    admin_test_aggregates_oil_testing_engine_master_data_engine_types_edit_id = 'admin/test-aggregates/oil-testing-engine-master-data/engine-types-edit-id',
    admin_test_aggregates_oil_testing_engine_master_data_engine_types_new_id = 'admin/test-aggregates/oil-testing-engine-master-data/engine-types-new-id',
    admin_test_aggregates_oil_testing_engine_master_data_test_stand_edit = 'admin/test-aggregates/oil-testing-engine-master-data/test-stand-edit',
    admin_test_aggregates_oil_testing_engine_master_data_test_stand_new = 'admin/test-aggregates/oil-testing-engine-master-data/test-stand-new',
    admin_test_aggregates_oil_testing_engine_master_data_test_stand_edit_id = 'admin/test-aggregates/oil-testing-engine-master-data/test-stand-edit-id',
    admin_test_aggregates_oil_testing_engine_master_data_test_stand_new_id = 'admin/test-aggregates/oil-testing-engine-master-data/test-stand-new-id',
    admin_test_aggregates_oil_testing_engine_master_data_test_substances_edit = 'admin/test-aggregates/oil-testing-engine-master-data/test-substances-edit',
    admin_test_aggregates_oil_testing_engine_master_data_test_substances_new = 'admin/test-aggregates/oil-testing-engine-master-data/test-substances-new',
    admin_test_aggregates_oil_testing_engine_master_data_test_substances_edit_id = 'admin/test-aggregates/oil-testing-engine-master-data/test-substances-edit-id',
    admin_test_aggregates_oil_testing_engine_master_data_test_substances_new_id = 'admin/test-aggregates/oil-testing-engine-master-data/test-substances-new-id',
    admin_test_aggregates_oil_testing_engine_master_data_test_bench_results_edit = 'admin/test-aggregates/oil-testing-engine-master-data/test-bench-results-edit',
    admin_test_aggregates_oil_testing_engine_master_data_test_bench_results_new = 'admin/test-aggregates/oil-testing-engine-master-data/test-bench-results-new',
    admin_test_aggregates_oil_testing_engine_master_data_test_bench_results_edit_id = 'admin/test-aggregates/oil-testing-engine-master-data/test-bench-results-edit-id',
    admin_test_aggregates_oil_testing_engine_master_data_test_bench_results_new_id = 'admin/test-aggregates/oil-testing-engine-master-data/test-bench-results-new-id',
    admin_test_aggregates_oil_testing_engine_master_data_invoice_data_edit = 'admin/test-aggregates/oil-testing-engine-master-data/invoice-data-edit',
    admin_test_aggregates_oil_testing_engine_master_data_invoice_data_new = 'admin/test-aggregates/oil-testing-engine-master-data/invoice-data-new',
    admin_test_aggregates_oil_testing_engine_master_data_invoice_data_edit_id = 'admin/test-aggregates/oil-testing-engine-master-data/invoice-data-edit-id',
    admin_test_aggregates_oil_testing_engine_master_data_invoice_data_new_id = 'admin/test-aggregates/oil-testing-engine-master-data/invoice-data-new-id',

    admin_management = 'admin/management',
    admin_management_news = 'admin/management/news',
    admin_management_news_create = 'admin/management/news_create',
    admin_management_news_create_id = 'admin/management/news/new_id',
    admin_management_news_edit = 'admin/management/news_edit',
    admin_management_news_edit_id = 'admin/management/news/edit_id',
    admin_management_service_area = 'admin/management/service-area',
    admin_management_service_area_new = 'admin/management/service-area/service-area-new',
    admin_management_service_area_edit = 'admin/management/service-area/service-area-edit',
    admin_management_service_area_edit_id = 'admin/management/service-area/service-area-edit/edit_id',
    admin_management_faq = 'admin/management/faq',
    admin_management_faq_new = 'admin/management/service-area/faq-new',
    admin_management_faq_edit = 'admin/management/service-area/faq-edit',

    admin_external_applications = 'admin/external-applications',
    admin_external_applications_operating_fluid_website = 'admin/external-applications/operating-fluid-website',
    admin_external_applications_bmaterial_api = 'admin/external-applications/bmaterial-api',
    admin_external_applications_fluidfinder = 'admin/external-applications/fluidfinder',
    admin_external_applications_fuels_db = 'admin/external-applications/fuels-db',

    //OIDC Login
    oidc_login = 'oidc/login',
    logout = 'logout',
}
